Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleTwttrLoad = void 0;
var _utils = require("../../utils");
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
var twttrEmbedScript = "\n!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0],p=/^http:/.test(d.location)?'http':'https';if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src=p+\"://platform.twitter.com/widgets.js\";fjs.parentNode.insertBefore(js,fjs);}}(document,\"script\",\"twitter-wjs\")\n";
var twttrLoad = function twttrLoad() {
  if (_typeof(window.twttr) !== "undefined" && window.twttr.widgets && _typeof(window.twttr.widgets.load) === "function") {
    window.twttr.widgets.load(document.getElementsByClassName("mdx-embed"));
  }
};
var handleTwttrLoad = function handleTwttrLoad() {
  if (!window.twttr) {
    (0, _utils.createScriptTag)(null, twttrEmbedScript);
    return {
      status: 'createScriptTag'
    };
  } else {
    twttrLoad();
    return {
      status: 'twttrLoad'
    };
  }
};
exports.handleTwttrLoad = handleTwttrLoad;